import { createQueryKeys } from '@lukemorales/query-key-factory';
import { UploadService } from '../service';
export const uploadQueries = createQueryKeys('upload', {
    config: (type) => ({
        queryKey: [type],
        queryFn: () => UploadService.getUploadConfig(type)
    }),
    filesByEntityType: (entityId, entityType) => ({
        queryKey: [entityId, entityType],
        queryFn: () => UploadService.getFilesByEntityType(entityId, entityType)
    })
});
